import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const MoreActionsIcon: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => (
    <svg
        className={`${className} ${styles.moreActionsIcon}`}
        data-testid={testId}
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M6.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM18.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default MoreActionsIcon;
